namespace TotalContest {
    import Service = TotalCore.Common.Service;

    @Service('services.totalcontest')
    export class RepositoryService {
        public resource;

        constructor($resource, prefix, ajaxEndpoint) {
            this.resource = $resource(ajaxEndpoint, {}, {
                saveOptions: {
                    method: 'POST',
                    params: {action: `${prefix}_options_save_options`}
                },
                migrateContests: {
                    method: 'POST',
                    params: {action: `${prefix}_options_migrate_contests`}
                },
                purge: {
                    method: 'POST',
                    params: {action: `${prefix}_options_purge`},
                }
            });

            return this;
        }

        getDebugInformation() {
            return window['TotalContestDebugInformation'] || {};
        }

        getExpressions() {
            return window['TotalContestExpressions'] || {};
        }

        getMigrationPlugins() {
            return window['TotalContestMigrationPlugins'] || {};
        }

        getOptions() {
            return window['TotalContestOptions'] || {};
        }

        postMigrateContests(plugin) {
            return this.resource.migrateContests({plugin: plugin}).$promise;
        }

        postOptions(options) {
            return this.resource.saveOptions({options: options}).$promise;
        }

        postPurge(type) {
            return this.resource.purge({type: type}).$promise;
        }
    }
}
